import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  TextField,
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useIntl, FormattedMessage } from 'react-intl';
import axiosServices from "../../../utils/axios";

const FAQList = () => {
  const [faqs, setFaqs] = useState([]);
  const [search, setSearch] = useState('');
  const intl = useIntl();

  const fetchFaqs = async () => {
    try {
      const res = await axiosServices.get('/communication/faq/');
      setFaqs(res.data);
    } catch (error) {
      setFaqs([]);
    }
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  const filteredFaqs = faqs.filter(
    (faq) =>
      faq.question.toLowerCase().includes(search.toLowerCase()) ||
      faq.answer.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Box sx={{ width: '100%' }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} sx={{ mb: 3 }}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <HelpOutlineIcon color="primary" sx={{ fontSize: 36 }} />
          <Typography variant="h4" fontWeight={700}>
            <FormattedMessage id="faq" defaultMessage="FAQ" />
          </Typography>
        </Stack>
        <TextField
          label={intl.formatMessage({ id: 'search', defaultMessage: 'Search' })}
          variant="outlined"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder={intl.formatMessage({ id: 'typeToSearch', defaultMessage: 'Type to search...' })}
          sx={{ width: { xs: '100%', sm: 300 } }}
        />
      </Stack>
      <Paper elevation={3} sx={{ p: 3, width: '100%' }}>
        {filteredFaqs.length === 0 ? (
          <Typography align="center">
            <FormattedMessage id="notFound" defaultMessage="Not found." />
          </Typography>
        ) : (
          filteredFaqs.map((faq) => (
            <Accordion key={faq.id} sx={{ width: '100%' }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={`faq-content-${faq.id}`} id={`faq-header-${faq.id}`}>
                <Typography variant="h6">{faq.question}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body1">{faq.answer}</Typography>
              </AccordionDetails>
            </Accordion>
          ))
        )}
      </Paper>
    </Box>
  );
};

export default FAQList;